import { post } from '../../../services/RestTemplate';

const loginUrl = '/auth/login';

export function login(username, password) {
    return post(loginUrl, { username: username, password: password });
}
